export const heroLead = {
  kicker: "本周深挖",
  title: "直播团队「断崖式掉粉」始末：一条置顶评论如何演变成品牌解约",
  excerpt:
    "从一条被置顶的粉丝评论开始，48 小时内该账号掉粉 60 万，随后品牌方连夜下架联名系列。我们把公开可见的每一步动作都按时间顺序还原，附上被删除的两条动态与三方回应原文。",
  meta: "时间线 · 9 个节点",
  readTime: "约 12 分钟读完",
  img: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20aesthetic%2C%20dramatic%20silhouette%20of%20a%20crowd%20holding%20glowing%20phone%20screens%20in%20dark%20hall%2C%20warm%20cream%20paper%20backdrop%2C%20muted%20vermillion%20and%20amber%20color%20grading%2C%20subtle%20film%20grain%2C%20high%20contrast%20negative%20space%2C%20contemporary%20art%20direction&width=900&height=1100&seq=hh-hero-lead&orientation=portrait",
};

export const heroSideCards = [
  {
    kicker: "事件梳理",
    title: "音乐节临时改期风波：三次反转之间到底发生了什么",
    excerpt: "主办方、场地方与参演阵容各执一词，我们把三条公开说法摆在一起对照。",
    meta: "时间线 · 6 个节点",
    img: "https://readdy.ai/api/search-image?query=editorial%20magazine%20photo%20of%20an%20empty%20open%20air%20music%20festival%20stage%20at%20dusk%20with%20scattered%20amber%20lights%2C%20warm%20cream%20haze%2C%20muted%20vermillion%20accents%2C%20grainy%20film%20texture%2C%20wide%20negative%20space%20composition&width=720&height=470&seq=hh-hero-sub-1&orientation=landscape",
  },
  {
    kicker: "原文对照",
    title: "三版声明逐句对比：被删掉的第 4 段究竟写了什么",
    excerpt: "同一份声明在一日内出现三个版本，我们标出了每一处被改动的字句。",
    meta: "原文 · 3 份材料",
    img: "https://readdy.ai/api/search-image?query=editorial%20flatlay%20of%20three%20printed%20documents%20with%20large%20abstract%20text%20blocks%20and%20red%20circle%20marks%2C%20warm%20cream%20desk%2C%20muted%20vermillion%20and%20ink%20tones%2C%20grainy%20film%20texture%2C%20top%20down%20art%20direction&width=720&height=470&seq=hh-hero-sub-2&orientation=landscape",
  },
];

export const flashTicker = [
  "某品牌联名上线 6 小时即下架，官方称「档期调整」",
  "话题词条两度登上热榜前十，讨论量突破 240 万",
  "当事账号删除全部置顶内容，仅保留一条致歉",
  "第三方数据平台：24 小时内相关视频新增 1.8 万条",
  "场地方发布补充说明，首次公开退票方案",
  "联名合作方回应：将暂停后续全部投放计划",
];

export const newsFlash = [
  { time: "09:12", text: "当事账号恢复更新，首条内容为一分钟纯文字声明视频。", tag: "进展" },
  { time: "08:40", text: "第二个合作品牌下架联名页面，客服统一话术改为「暂时缺货」。", tag: "品牌" },
  { time: "07:55", text: "话题新增讨论量 12.6 万，情绪倾向统计显示质疑占比升至 68%。", tag: "数据" },
  { time: "01:20", text: "疑似当事人小号发文又秒删，截图在两小时内被转发 4 万次。", tag: "求证" },
  { time: "23:47", text: "主办方深夜发布第二版说明，补充了此前提到的场地审批材料。", tag: "回应" },
  { time: "22:10", text: "首批现场观众放出完整版视频，与原流传剪辑片段存在 17 秒差异。", tag: "原文" },
  { time: "21:05", text: "相关话题冲上榜首，停留时长 3 小时 12 分。", tag: "热度" },
  { time: "19:30", text: "工作室首次回应，表示已委托第三方机构进行核查。", tag: "首发" },
];

export const timelineNodes = [
  {
    date: "09·03",
    time: "21:05",
    tag: "起因",
    title: "一条被置顶的评论",
    desc: "当事账号将一条质疑其内容真实性的评论置顶，并回复「稍后统一说明」，成为整起事件的起点。",
    img: "https://readdy.ai/api/search-image?query=close%20up%20editorial%20photo%20of%20a%20single%20self%20lit%20phone%20screen%20in%20the%20dark%20showing%20abstract%20chat%20bubbles%2C%20warm%20cream%20and%20muted%20vermillion%20grading%2C%20grainy%20film%20texture%2C%20minimal%20composition&width=260&height=260&seq=hh-tl-1&orientation=squarish",
  },
  {
    date: "09·04",
    time: "10:22",
    tag: "发酵",
    title: "两个话题同时上榜",
    desc: "围绕该评论出现了两个方向相反的话题词条，双方各自引用不同的截图，讨论量在 4 小时内翻了三倍。",
    img: "https://readdy.ai/api/search-image?query=editorial%20abstract%20photo%20of%20two%20diverging%20paper%20strips%20forming%20an%20arrow%20split%2C%20warm%20cream%20surface%2C%20muted%20vermillion%20and%20amber%20grading%2C%20grainy%20film%20texture%2C%20graphic%20minimal%20composition&width=260&height=260&seq=hh-tl-2&orientation=squarish",
  },
  {
    date: "09·04",
    time: "18:03",
    tag: "反转",
    title: "第一版声明发布后又修改",
    desc: "首份声明在发布 40 分钟后被替换，删除了关于「内部沟通」的一段表述，修改记录被网友截图留存。",
    img: "https://readdy.ai/api/search-image?query=editorial%20close%20up%20of%20a%20printed%20page%20being%20torn%20along%20a%20fold%2C%20warm%20cream%20paper%2C%20muted%20vermillion%20ink%20stains%2C%20grainy%20film%20texture%2C%20minimal%20studio%20composition&width=260&height=260&seq=hh-tl-3&orientation=squarish",
  },
  {
    date: "09·05",
    time: "09:41",
    tag: "波及",
    title: "品牌方连夜下架联名",
    desc: "首个合作品牌清空联名专区，客服话术统一调整；随后第二个品牌跟进，联名系列全线下架。",
    img: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20an%20empty%20retail%20shelf%20with%20blank%20price%20tags%2C%20warm%20cream%20background%2C%20muted%20vermillion%20accent%20strip%2C%20grainy%20film%20texture%2C%20minimal%20composition&width=260&height=260&seq=hh-tl-4&orientation=squarish",
  },
  {
    date: "09·06",
    time: "14:16",
    tag: "求证",
    title: "完整版视频出现 17 秒差异",
    desc: "现场观众放出未剪辑原片，与广泛流传的片段相差 17 秒。这段差异成为后续讨论的关键证据。",
    img: "https://readdy.ai/api/search-image?query=editorial%20still%20of%20a%20small%20camera%20viewport%20frame%20marker%20over%20blurred%20abstract%20scene%2C%20warm%20cream%20and%20amber%20grading%2C%20grainy%20film%20texture%2C%20minimal%20graphic%20composition&width=260&height=260&seq=hh-tl-5&orientation=squarish",
  },
  {
    date: "09·07",
    time: "02:08",
    tag: "收束",
    title: "第三方机构介入核查",
    desc: "当事人委托第三方机构对争议内容进行核查，并公开了委托函的部分内容，事件进入相对平静的求证阶段。",
    img: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20sealed%20envelope%20and%20stamp%20on%20warm%20cream%20desk%2C%20muted%20vermillion%20seal%2C%20grainy%20film%20texture%2C%20minimal%20top%20down%20composition&width=260&height=260&seq=hh-tl-6&orientation=squarish",
  },
];

export const deepDives = [
  {
    tag: "深挖 · 商业",
    title: "联名经济里的「解约成本」到底多大",
    desc: "从物料制作到渠道下架，我们拆解一次突发解约涉及的六个成本环节与常见处理周期。",
    count: "6 个拆解点",
    img: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20abstract%20stacked%20cardboard%20shipping%20boxes%20with%20blank%20labels%20in%20warm%20cream%20studio%2C%20muted%20vermillion%20and%20amber%20grading%2C%20grainy%20film%20texture%2C%20minimal%20art%20direction&width=820&height=560&seq=hh-dd-1&orientation=landscape",
  },
  {
    tag: "深挖 · 传播",
    title: "从截图到热榜：一条信息的三次变形",
    desc: "同一段内容在不同平台的转述中会发生什么变化，我们用三张对照表还原传播路径。",
    count: "3 张对照表",
    img: "https://readdy.ai/api/search-image?query=editorial%20abstract%20photo%20of%20overlapping%20translucent%20paper%20layers%20casting%20soft%20shadows%2C%20warm%20cream%20palette%20with%20muted%20vermillion%20edge%2C%20grainy%20film%20texture%2C%20minimal%20studio%20composition&width=820&height=560&seq=hh-dd-2&orientation=landscape",
  },
  {
    tag: "深挖 · 原文",
    title: "被删掉的第 4 段：文本比对方法论",
    desc: "教你用最朴素的方式对照两个版本的声明，找出被改动、被删减与被补充的部分。",
    count: "附比对模板",
    img: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20two%20printed%20pages%20side%20by%20side%20with%20abstract%20text%20blocks%20and%20pencil%20marks%2C%20warm%20cream%20desk%2C%20muted%20vermillion%20annotation%2C%20grainy%20film%20texture&width=820&height=560&seq=hh-dd-3&orientation=landscape",
  },
  {
    tag: "深挖 · 时间",
    title: "48 小时黄金窗口：回应越早越好吗",
    desc: "统计近三年 25 起同类事件的首发间隔与舆情走向，看看回应时机与结果之间的关系。",
    count: "25 个样本",
    img: "https://readdy.ai/api/search-image?query=editorial%20abstract%20photo%20of%20a%20large%20analog%20clock%20face%20made%20of%20paper%20on%20warm%20cream%20wall%2C%20muted%20vermillion%20hand%2C%20grainy%20film%20texture%2C%20minimal%20composition&width=820&height=560&seq=hh-dd-4&orientation=landscape",
  },
];

export const archiveItems = [
  {
    source: "当事方官方账号",
    date: "09·04 18:03",
    title: "第一版声明（已被替换）",
    quote:
      "关于近期讨论，我们已第一时间进行内部沟通，并将于完成后统一说明。对于由此带来的困扰，我们深表歉意。",
    tag: "原文",
  },
  {
    source: "合作品牌客服中心",
    date: "09·05 09:41",
    title: "联名下架的官方答复话术",
    quote:
      "该系列目前为暂时缺货状态，后续上架时间请以官方公告为准。已下单用户可正常申请退款，不受影响。",
    tag: "原文",
  },
  {
    source: "主办方公告栏",
    date: "09·06 23:47",
    title: "第二版说明（补充场地材料）",
    quote:
      "本次调整系场地审批流程所致，相关材料已于今日补充提交。退票通道将在公告发布后 24 小时内开启。",
    tag: "原文",
  },
];

export const backgroundFiles = [
  { type: "PDF", title: "事件完整时间线对照表", desc: "含 9 个节点与三方说法并列", size: "2.4 MB" },
  { type: "DOCX", title: "两版声明逐句比对稿", desc: "标注删除、改写与补充位置", size: "860 KB" },
  { type: "XLSX", title: "话题热度分钟级数据", desc: "覆盖 48 小时讨论量变化", size: "1.1 MB" },
  { type: "ZIP", title: "公开展示素材包", desc: "截图与公开二维码备份", size: "18.6 MB" },
];

export const trendList = [
  { rank: 1, title: "联名系列全线下架", heat: 986, tag: "商业", change: "up" },
  { rank: 2, title: "完整版视频 17 秒差异", heat: 842, tag: "原文", change: "up" },
  { rank: 3, title: "第一版声明被替换记录", heat: 771, tag: "文本", change: "down" },
  { rank: 4, title: "场地方退票方案", heat: 668, tag: "回应", change: "up" },
  { rank: 5, title: "第三方机构介入核查", heat: 594, tag: "进展", change: "down" },
  { rank: 6, title: "小号秒删截图溯源", heat: 512, tag: "求证", change: "up" },
];

export const navLinks = [
  { label: "时间线", href: "#timeline" },
  { label: "快讯流", href: "#flash" },
  { label: "原文收录", href: "#archive" },
  { label: "背景资料", href: "#background" },
  { label: "热度榜", href: "#board" },
];

export const footerColumns = [
  {
    title: "阅读入口",
    links: ["最新时间线", "原文收录库", "背景资料馆", "热度总榜"],
  },
  {
    title: "内容方向",
    links: ["商业与品牌", "传播与文本", "公开信息求证", "时间线方法论"],
  },
  {
    title: "关于本站",
    links: ["站点说明", "资料来源规则", "内容更正流程", "联系编辑部"],
  },
];